import React from 'react';
import { withHash } from '../HOCs';
import JumplinkAnchor from '../JumplinkAnchor';
import JumplinkFallback from '../JumplinkFallback';

const Jumplink = ({ hasJumplink, jumplinkLabel }: any) => {
  if (hasJumplink) return <JumplinkAnchor jumplinkLabel={jumplinkLabel} />;

  return <JumplinkFallback jumplinkLabel={jumplinkLabel} />;
};

export const HashedJumplink = withHash({ Component: Jumplink });

export default Jumplink;
